'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { type AdpopcornSspEventData, MESSAGE_KEYWORD, subscribeAppEvents } from '@/modules/wello-app';

/**
 * 앱이 포워딩하는 AdPopcorn SSP 이벤트(ADPOPCORN_SSP_EVENT) 구독 훅.
 * 전면영상/리워드영상 SDK 이벤트를 { module, event, payload }로 받는다.
 */
export const useAdpopcornSspEvents = handler => {
  const $ = _c(4);
  const handlerRef = useRef(handler);
  let t0;
  if ($[0] !== handler) {
    t0 = () => {
      handlerRef.current = handler;
    };
    $[0] = handler;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(t0);
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => subscribeAppEvents(message => {
      if (message.type !== MESSAGE_KEYWORD.ADPOPCORN_SSP_EVENT) {
        return;
      }
      handlerRef.current(message.data as AdpopcornSspEventData);
    });
    t2 = [];
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
};